import { render, staticRenderFns } from "./confirm-lead.vue?vue&type=template&id=4d947ae4&scoped=true&"
import script from "./confirm-lead.vue?vue&type=script&lang=js&"
export * from "./confirm-lead.vue?vue&type=script&lang=js&"
import style0 from "./confirm-lead.vue?vue&type=style&index=0&id=4d947ae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d947ae4",
  null
  
)

export default component.exports